module.exports = __webpack_public_path__ + "img/Website SignIn.d697967d.svg";